export default {
  init() {
    $('#filter').submit(function() {
      var filter = $('#filter');
      $.ajax({
        url:filter.attr('action'),
          data:filter.serialize(), // form data
          type:filter.attr('method'), // POST
          beforeSend:function(xhr) {
            filter.find('button span').text('Processing...'); // changing the button label
          },
          success:function(data) {
            filter.find('button span').text('Search'); // changing the button label back
            $('#initial').hide();
            $('#response').html(data); // insert data
          },
        });
      return false;
    });

    window.renderAsset = function(file, type) {
      document.querySelector('.spinner').style.display = 'block';
      $('#asset-rev').foundation('open');
      setTimeout(() => {
        let postData = type+'&'+file;
        $.ajax({
         type: "POST",
         url: '/wp-content/themes/sage-foundation/resources/render-ajax.php',
         data: { file: file, type: type },
         beforeSend:function(data) {
           document.querySelector('.spinner').style.display = 'block';
         },
         success:function(data) {
          document.querySelector('.spinner').style.display = 'none';
          $('#asset-rev').html(data);
        },
      });
      }, '500');
    }

  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/postTypeArchivePtc_resources.js